import { css } from "../../../../../styled-system/css";

export const styles = {
  wrapper: () =>
    css({
      textAlign: "left",
      fontSize: "body.butterfly",
      lineHeight: "body.butterfly",
      letterSpacing: "body.butterfly",
      desktop: {
        fontSize: "body.mouse",
        lineHeight: "body.mouse",
        letterSpacing: "body.mouse",
      },
    }),
  primaryLine: () =>
    css({
      fontWeight: 800,
      color: "black",
      fontSize: "body.butterfly",
      lineHeight: "body.butterfly",
      letterSpacing: "body.butterfly",
      desktop: {
        fontSize: "body.mouse",
        lineHeight: "body.mouse",
        letterSpacing: "body.mouse",
      },
    }),
  secondaryLine: () =>
    css({
      color: "black",
      fontSize: "body.butterfly",
      lineHeight: "body.butterfly",
      letterSpacing: "body.butterfly",
      desktop: {
        fontSize: "body.mouse",
        lineHeight: "body.mouse",
        letterSpacing: "body.mouse",
      },
    }),
  link: () =>
    css({
      "& button, & a": {
        fontSize: "body.butterfly",
        lineHeight: "body.butterfly",
        letterSpacing: "body.butterfly",
        desktop: {
          fontSize: "body.mouse",
          lineHeight: "body.mouse",
          letterSpacing: "body.mouse",
        },
      },
    }),
  separator: () =>
    css({
      color: "black",
      fontWeight: 800,
      fontSize: "body.butterfly",
      lineHeight: "body.butterfly",
      letterSpacing: "body.butterfly",
      desktop: {
        fontSize: "body.mouse",
        lineHeight: "body.mouse",
        letterSpacing: "body.mouse",
      },
    }),
};
